import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { addPageObject, addPageObjectOffline } from "../../../../store/actions/pages";
import withLayout from "../../common/layout";
import { AddButton, BoxDiv, CalendarBox, CalendarTable, Count, DashboardSection, DayCell, DropTarget, EmployeeCell, EmployeeCellTD, IconWrapper, SettingsBox, Tile, Title, TitleBox } from "./styles";
import { GetIcon } from "../../../../icons";
import { useTranslation } from "react-i18next";
import { convertMinutesToHHMM, formatDateToDayAndDate } from "../../../functions/dataFormat";
import { Container } from "../../common/layout/styels";
import moment from "moment";
import { generateThumbnail } from "../../../functions/string";
import { Filter1 } from "../../../elements/dateselector/styles";
import { NoData } from "../../../elements/list/styles";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { getData, postData } from "../../../../backend/api";
import Checkbox from "../../../elements/checkbox";
import PopupView from "../../../elements/popupview";
import { dateFormat } from "../../../functions/date";
import i18n from "i18next";
import { Link, useNavigate } from "react-router-dom";
import { DisplayInformations } from "../../../elements/list/popup";
import ReactApexChart from "react-apexcharts";

const Dashboard = (props) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const themeColors = useSelector((state) => state.themeColors);
  const [initialized, setInitialized] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const [organisedData, setOrganisedData] = useState({});
  const [dashboardDefault, setDashboardDefault] = useState([]);
  const [leavesData, setLeavesData] = useState({});
  const [currentDate, setCurrentDate] = useState(moment());
  const dashboard = useSelector((state) =>
    state.pages[`dashboard`]
      ? state.pages[`dashboard`]
      : {
          data: null,
          isLoading: true,
          error: null,
        }
  );

  useEffect(() => {
    document.title = `${t("dashboard")} - Whistleblowing24`;
  }, [t]);

  const user = useSelector((state) => state.login)
  const [selectedLanguage] = useState(i18n.language || "de");
  const dashboardOrder = useSelector((state) => (state.pages[`dashboardOrder`] ? state.pages[`dashboardOrder`] : []));
  // const [birthdays, setBirthday] = useState(dashboard?.data?.birthdays ?? []);
  // const [leaves, setLeaves] = useState(dashboard?.data?.leaves ?? []);
  const [state, setState] = useState(null);
  let date = new Date();
  useEffect(() => {
    // setBirthday(dashboard?.data?.birthdays ?? []);
    // setLeaves(dashboard?.data?.leaves ?? []);
    const data = {};
    if (dashboard?.data?.dashboard) {
      data["status"] = dashboard?.data?.status;
    }
    if (dashboard?.data?.companyPerCountry && dashboard?.data?.companyPerCountry.length > 0) {
      let series = [];
      let labels = [];
      dashboard?.data?.companyPerCountry.map((item) => {
        const natName = sessionStorage.getItem('_lang') 
            ? item[sessionStorage.getItem('_lang')] || item.de 
            : item.de;
        series.push(item.count);
        labels.push(natName);
      });
      setState({  
        series: series,
        options: {
          chart: {
            width: 380,
            type: 'pie',
          },
          labels: labels,
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        },
      
      
    })
    }
    setOrganisedData(data);
    setDashboardDefault(dashboard?.data?.dashboardDefault ?? []);
  }, [dashboard]);

  useEffect(() => {
    props.setLoaderBox(dashboard.isLoading);
    dashboard.isLoading && setInitialized(true);
  }, [dashboard, props]);

  useEffect(() => {
    if (initialized) {
      dispatch(addPageObject("dashboard", 0, {}));
    }
  }, [initialized, dispatch]);

  useEffect(() => {}, [dashboard]);
  const GetValue = (type, itemValue) => {
    switch (type) {
      case "minute":
        return convertMinutesToHHMM(parseFloat(itemValue ?? 0));
      default:
        return itemValue ?? 0;
    }
  };
  
  const DraggableDashboard = ({ data, className = "", index }) => {
    const [isDragging, setIsDragging] = useState(false);
    const [isdrop, setIsDrop] = useState(false);
    const [over, setOver] = useState(false);

    const [, drag] = useDrag({
      type: "ITEM",
      item: { index: index }, // Use 'item' to specify the data being dragged
      collect: (monitor) => {
        setIsDragging(monitor.isDragging());
        return {};
      },
    });

    return (
      <>
        {/* <div> </div> */}
        <BoxDiv style={{position:'relative',borderRadius:'10px'}}>
          <div style={{position:'absolute',left:0,right:0,top:0,bottom:0,zIndex: isdrop?10:-1}}>{DropHere(index,setIsDrop,setOver)}</div>

          <BoxDiv style={{visibility: over? 'hidden':'visible', opacity: isDragging ? 0.5 : 1, border:'none',height:'calc(100% - 20px)'}} ref={drag} className="plain">
            <CalendarBox >{data}</CalendarBox>
          </BoxDiv>
        </BoxDiv>
      </>
    );
  };
  const DropHere = (index = 0,setIsDrop,setOver) => {
    const [{ isOver, canDrop }, drop] = useDrop({
      accept: "ITEM",
      hover: (draggedItem) => {
        const draggedIndex = draggedItem.index;
        if (draggedIndex !== index) {
          console.log("no");
        }
      },
      drop: (draggedItem) => {
        // Logic to handle drop event
        console.log(index, draggedItem.index);
        const draggedIndex = draggedItem.index;
        if (draggedIndex !== index) {
          // Swap the dashboards
          const updatedDashboards = [...dashboardOrder];
          // const temp = updatedDashboards[index];
          // updatedDashboards[index] = updatedDashboards[draggedIndex];
          // updatedDashboards[draggedIndex] = temp;
          const draggedItem = updatedDashboards.splice(draggedIndex, 1)[0];

          // Insert the dragged item at the new position
          updatedDashboards.splice(index, 0, draggedItem);
          postData({ dashboardOrder: updatedDashboards }, "admin/update-dashboard", dispatch, navigate);
          dispatch(addPageObjectOffline("dashboardOrder", updatedDashboards ?? []));
          // Update the dashboard state
        }
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    });

    useEffect(() => {
      setIsDrop(canDrop);
      setOver(isOver)
    }, [canDrop,isOver])

    
    

    return (
      (
        <DropTarget
          ref={drop}
          style={{
            backgroundColor: isOver? "white" : "transparent",
            minHeight: "172px",
            border: isOver? "1px dashed #aaa;" : "none",
          }}
        >
          {isOver ? <span>{t("Move here")}</span> : null}
        </DropTarget>
      )
    );
  };

  const generateView = ({ type, data, index }) => {
    switch (type) {
      case "status":
      case "hourlyStatistics":
        return (
          <DraggableDashboard
            key={"item" + index}
            index={index}
            className="two"
            data={
              dashboard?.data?.[type].length > 0 ? (
                <BoxDiv className="radious" style={{border:'none'}}>
                  <div className="head" style={{borderBottom: '2px solid #d6e0ff'}}>
                  <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
                    <GetIcon icon={type} />
                    {t("dash-" + type)}
                  </div>
                  </div>
                  <BoxDiv className="two plain">
                    {dashboard?.data?.[type].map((item, index) =>
                      item.icon === "leaveType" ? (
                        <Tile key={`dashboard-${index}`}>
                          <TitleBox>
                            <Count>
                              {item.data.map((count) => (
                                <span className={count.status} key={count.status}>
                                  <GetIcon icon={count.status} />
                                  {GetValue(item.type, count.count ?? 0)}
                                </span>
                              ))}
                            </Count>
                            <Title>{t(item.title)}</Title>
                          </TitleBox>
                        </Tile>
                      ) : (
                        <Tile key={index}>
                          <TitleBox>
                            <Count>{GetValue(item.type, item.count ?? 0)}</Count>
                            <Title>{t(item.title)}</Title>
                          </TitleBox>
                          <IconWrapper style={{ background: item.background, color: item.color }}>
                            <GetIcon icon={item.icon} />
                          </IconWrapper>
                        </Tile>
                      )
                    )}
                  </BoxDiv>
                </BoxDiv>
              ) : null
            }
          />
        );
      default:
        return (
          <DraggableDashboard
            key={"item" + index}
            index={index}
            data={
              <BoxDiv>
                <NoData className="cover">{t("notFound", { page: t(type) })}</NoData>
              </BoxDiv>
            }
          />
        );
    }
  };
  const addDashboard = (title) => {
    let updatedDashboards = [...dashboardOrder];

    // Check if the title is already in the dashboardOrder
    const index = updatedDashboards.findIndex((item) => item === title);

    if (index === -1) {
      // If not in the array, add it
      updatedDashboards.push(title);
    } else {
      // If already in the array, remove it
      updatedDashboards = updatedDashboards.filter((item, i) => i !== index);
    }

    // Assuming postData and setDashboardOrder are defined elsewhere in your code
    postData({ dashboardOrder: updatedDashboards }, "admin/update-dashboard", dispatch, navigate);

    dispatch(addPageObjectOffline("dashboardOrder", updatedDashboards ?? []));
  };

  return (
    <Container className="noshadow column">
      {openSettings && (
        <PopupView
          themeColors={themeColors}
          openData={{ data: { settings: "dashboardSettings" } }}
          itemTitle={{ name: "settings", collection: "" }}
          popupData={
            <SettingsBox>
              {dashboardDefault.map((item) => {
                const has = dashboardOrder.some((order) => order === item);
                return (
                  // <Button onClick={() => addDashboard(item)}>{t(item)}</Button>
                  <Checkbox label={t("dash-" + item)} checked={has} onChange={() => addDashboard(item)} />
                );
              })}
            </SettingsBox>
          }
          customClass={"small"}
          closeModal={() => {
            setOpenSettings(false);
          }}
        ></PopupView>
      )}

      <DndProvider backend={HTML5Backend}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center',padding:"10px 0 30px 0"}}>
          <div style={{backgroundColor:'transparent', color:'#0C3090'}} className="plain">
            <div style={{fontWeight:'bold'}}>{t(formatDateToDayAndDate(date).dayName)}, {formatDateToDayAndDate(date).fullDate}</div>
            <div style={{fontSize:'30px',fontWeight:'bold',marginTop:'10px'}}>{t("Hello")} {user?.data?.user?.fullName?.split(' ')[0]},</div>
          </div>
          <AddButton onClick={() => setOpenSettings((prev) => !prev)}>
            <GetIcon icon={"editDashboard"}></GetIcon> {t("edit")}
          </AddButton>
        </div>
        {/* {dashboardOrder?.length > 0 && ( */}
          <DashboardSection count={((dashboardOrder?.length) / 2).toFixed(0)} className="two">
            {/* <div className="">*/}
            {state && <BoxDiv className="radious">
                  <div className="head">
                  <div style={{display:'flex',gap:'10px',alignItems:'center', fontWeight:'bold', color:'#0C3090'}}>
                    <GetIcon icon={"dashboard"} />
                    {t("dash-" + "companyPerCountry")}
                  </div>
                  </div> 
                  <div>
            <div id="chart">
                <ReactApexChart options={state.options} series={state.series} type="pie" width={380} />
              </div>
            <div id="html-dist"></div>
          </div>
                </BoxDiv>}
                {/* </div> */}
                
            {dashboardOrder.map((page, index) => generateView({ data: organisedData[page] ?? [], type: page, index }))}
          </DashboardSection>
        {/* )} */}
      </DndProvider>

    </Container>
  );
};

export default withLayout(Dashboard);